import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioDomainEnum,
	getPortfolioDomainProducersV2,
	type ProductCategoryKeyEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useProducersQuery = (
	domain: ClientPortfolioDomainEnum | undefined,
	productCategory?: ProductCategoryKeyEnum,
) => {
	return useQuery({
		queryKey: PortfolioKeys.producers(domain!, productCategory),
		queryFn: processResponse(() =>
			getPortfolioDomainProducersV2(domain!, productCategory),
		),
		enabled: Boolean(domain),
	});
};
